import { FC } from 'react';

import AddressItem from './AddressItem/AddressItem';
import Heading from '@/components/common/Heading';

import { ContactsDataType } from '@/types';

interface IAddressProps {
  contactsData: ContactsDataType[];
}

const Address: FC<IAddressProps> = ({ contactsData }) => {
  return (
    <article className="flex flex-col md:flex-row gap-5 ">
      <Heading headingLevel="h2" className=" visually-hidden">
        Contact information for communication with company Code Solution
      </Heading>
      <ul
        className={
          'flex flex-1 flex-col gap-3 md:gap-10 p-[30px] bg-[#fafafa] rounded-[15px] shadow-[0_0_10px_-7px_#000]'
        }
      >
        {contactsData.map(
          ({
            id,
            icon,
            title,
            text,
            contacts,
            ariaLabel,
            address,
          }: ContactsDataType) => (
            <li key={id} className={''}>
              <AddressItem
                icon={icon}
                title={title}
                text={text}
                contacts={contacts}
                ariaLabel={ariaLabel}
                address={address}
              />
            </li>
          )
        )}
      </ul>
      <div className="flex-1 rounded h-[80%]">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11202.360266666157!2d-75.6978574!3d45.4176054!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cce054d365f596b%3A0xd33390a39bc5125e!2sCode%20Solution%20Experts!5e0!3m2!1sen!2sua!4v1687782935427!5m2!1sen!2sua"
          width="100%"
          height="400"
          style={{ border: 0 }}
          className="rounded-xl"
          allowFullScreen
          loading="lazy"
          lang="us"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </article>
  );
};

export default Address;
